import $ from 'jquery';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {useRolloutFlags} from 'launchdarkly/LaunchDarklyUtil';
import Omnibox from 'omnibox/Omnibox';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

class OmniboxErrorBoundary extends React.Component<{children: React.ReactNode}, {hasError: boolean}> {
  override state: {hasError: boolean} = {hasError: false};
  static getDerivedStateFromError(): {hasError: boolean} {
    return {hasError: true};
  }
  override componentDidCatch(error: Error): void {
    // eslint-disable-next-line no-console
    console.error('Omnibox crashed:', error);
  }
  override render(): React.ReactNode {
    return this.state.hasError ? null : this.props.children;
  }
}

function GatedOmnibox(): JSX.Element | null {
  const {llmEnableOmnibox} = useRolloutFlags();
  // Vector-search tenants get the omnibox (in its search-only mode) even without the full LLM
  // omnibox rollout, so vector chunk search is reachable regardless of LLM enablement.
  if (!llmEnableOmnibox && !BenchlingConfig.SEARCH_ENABLE_OMNIBOX_VECTOR_SEARCH) {
    return null;
  }
  return <Omnibox />;
}

export function init(): void {
  const $container = $('<div>').addClass('omnibox-container');
  $('body').append($container);
  renderToDOM(
    <OmniboxErrorBoundary>
      <GatedOmnibox />
    </OmniboxErrorBoundary>,
    $container[0]
  );
}
